import { Field } from 'contensis-core-api';
import { ContentTypeFieldValidationAssertions } from './ContentTypeFieldValidationAssertions';

export type FieldAssertion = (field: Field) => boolean;

export class ContentTypeFieldAssertions {
  static validation = ContentTypeFieldValidationAssertions;
  static IsAsset: FieldAssertion = (field) => field?.dataFormat === 'asset';
  static IsBoolean: FieldAssertion = (field) => field?.dataFormat === 'boolean';
  static IsCanvas: FieldAssertion = (field) => field?.dataFormat === 'canvas';
  static IsComponent: FieldAssertion = (field) =>
    !!field?.dataFormat?.startsWith('component.');
  static IsComposer: FieldAssertion = (field) =>
    field?.dataFormat === 'field' && field?.dataType === 'objectArray';
  static IsContentTypeResourcePicker: FieldAssertion = (field) =>
    ContentTypeFieldAssertions.IsResourcePicker(field) &&
    !!field.validations?.allowedDataFormats?.dataFormats.find(
      (df) => df === 'entry'
    );
  static IsFormResourcePicker: FieldAssertion = (field) =>
    ContentTypeFieldAssertions.IsResourcePicker(field) &&
    !!field.validations?.allowedDataFormats?.dataFormats.find(
      (df) => df === 'form'
    );

  static IsEntry: FieldAssertion = (field) => field?.dataFormat === 'entry';
  static IsHeading: FieldAssertion = (field) => field?.dataFormat === 'heading';
  static IsImage: FieldAssertion = (field) => field?.dataFormat === 'image';
  static IsList: FieldAssertion = (field) =>
    !!(
      field?.dataType.startsWith('string') &&
      field?.validations?.allowedValues?.values.length
    );
  static IsLocation: FieldAssertion = (field) =>
    field?.dataFormat === 'location';
  static IsMarkdown: FieldAssertion = (field) =>
    field?.dataFormat === 'markdown';
  static IsQuote: FieldAssertion = (field) => field?.dataFormat === 'quote';
  static IsRepeatable: FieldAssertion = (field) =>
    field?.dataType.endsWith('Array');
  static IsResourcePicker: FieldAssertion = (field) =>
    field?.dataFormat === 'contenttype';
  static IsRichText: FieldAssertion = (field) => field?.dataFormat === 'html';
  static IsTagPicker: FieldAssertion = (field) =>
    !!field?.dataFormat?.startsWith('tag.');
  static IsTaxonomy: FieldAssertion = (field) =>
    field?.dataFormat === 'taxonomy';
}
